function setByPath(obj, path, value) {
    let splittedPath = path.split('.');
    splittedPath.reduce((ns, p, i) => {
        if (i === splittedPath.length - 1) { // if it end of path
            ns[p] = value;
        } else {
            if (!ns) ns = {};
            if (!ns[p]) ns[p] = {};
            return ns[p];
        }
    }, obj);
    return obj;
}

class iFormData {

    #changedFields = {};


    constructor(data) {
        if (data) {
            if (typeof data === 'object') {
                Object.keys(data).forEach((key) => {
                    this[key] = data[key];
                })
            } else console.error("iFormData error! Unsupported type " + typeof data + '. Use only object as argument. ');
        }

    }

    setByPath(path, value) {
        setByPath(this, path, value);
        setByPath(this.#changedFields, path, value);
        return this;
    }
    getByPath(path) {
        let splittedPath = path.split('.');
        let lastEl = splittedPath[splittedPath.length - 1];

        let iter = splittedPath.reduce((ns, p) => {
            //console.log(ns, p)
            if (!ns[p]) {
                if (p !== lastEl) ns[p] = {};
            }
            return ns[p];
        }, this);
        //console.log(this,path,iter)
        return iter;
    }

    getChanged() {
        if (this._id) {
            return Object.assign({}, this.#changedFields, { _id: this._id });
        } else {
            return this.#changedFields;
        }
    }

}



window.iFormData = iFormData;